<template>
  <div class="home">
    <!-- 统一导航栏 -->
    <UnifiedNavBar />

    <!-- 主要内容区域 -->
    <main class="main-content">
      <!-- 科技感背景 -->
      <div class="hero-section">
        <!-- 首页背景图片 -->
        <div class="hero-background">
          <img 
            src="/imags/home_page.png" 
            alt="易博数字首页背景"
            class="hero-image"
          >
        </div>
        
        <!-- 图片叠加层 -->
        <div class="hero-overlay"></div>
        
        <!-- 主标题区域 -->
        <div class="hero-content">
          <div class="container">
            <h1 class="main-title fade-in-up">易博数字</h1>
            <p class="subtitle fade-in-up">Digital Solutions</p>
            <p class="description fade-in-up">
              专业的数字化解决方案服务商
            </p>
          </div>
        </div>
        
        
      </div>
      
      <!-- 产业布局模块 -->
      <IndustryLayout />
      
      <!-- Footer组件 -->
      <Footer />
    </main>
  </div>
</template>

<script>
import UnifiedNavBar from '@/components/UnifiedNavBar.vue'
import IndustryLayout from '@/components/IndustryLayout.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',
  components: {
    UnifiedNavBar,
    IndustryLayout,
    Footer
  },
  mounted() {
    // 页面加载完成后的处理
    this.initializePage()
  },
  methods: {
    initializePage() {
      // 页面初始化处理
      console.log('首页加载完成')
      // 可以在这里添加图片加载完成后的动画效果
      this.$nextTick(() => {
        const heroImage = document.querySelector('.hero-image')
        if (heroImage) {
          heroImage.addEventListener('load', () => {
            console.log('首页背景图片加载完成')
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  min-height: 100vh;
}

// 主要内容区域
.main-content {
  padding-top: 60px;
}

// 英雄区域
.hero-section {
  min-height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

// 首页背景图片
.hero-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.hero-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.9;
}

// 图片叠加层
.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: 
    linear-gradient(135deg, 
      rgba(15, 23, 42, 0.7) 0%, 
      rgba(30, 41, 59, 0.5) 25%, 
      rgba(51, 65, 85, 0.3) 50%, 
      rgba(30, 41, 59, 0.5) 75%, 
      rgba(15, 23, 42, 0.7) 100%),
    radial-gradient(circle at 20% 80%, rgba(59, 130, 246, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 20%, rgba(96, 165, 250, 0.08) 0%, transparent 50%);
  pointer-events: none;
}




  

















// 英雄内容
.hero-content {
  position: relative;
  z-index: 2;
  text-align: center;
  color: #ffffff;
  padding: 140px 0 100px;
  
  .container {
    max-width: 900px;
    margin: 0 auto;
    padding: 0 24px;
  }
  
  .main-title {
    font-size: 4rem;
    font-weight: 800;
    margin-bottom: 20px;
    line-height: 1.1;
    color: #ffffff;
    letter-spacing: -1px;
    text-shadow: 0 0 20px rgba(59, 130, 246, 0.5), 0 0 40px rgba(59, 130, 246, 0.3);
    
    @media (max-width: 768px) {
      font-size: 2.8rem;
    }
  }
  
  .subtitle {
    font-size: 1.4rem;
    margin-bottom: 40px;
    opacity: 0.9;
    font-weight: 400;
    letter-spacing: 1px;
    color: #93c5fd;
    text-shadow: 0 0 10px rgba(147, 197, 253, 0.3);
  }
  
  .description {
    font-size: 1.4rem;
    line-height: 1.7;
    margin-bottom: 50px;
    opacity: 0.9;
    max-width: 700px;
    margin-left: auto;
    margin-right: auto;
    color: #ffffff;
    text-shadow: 0 0 5px rgba(203, 213, 225, 0.2);
  }
  
  
}

 

// 响应式设计
@media (max-width: 768px) {
  .navbar {
    .nav-menu {
      display: none;
    }
  }
  
  .earth-container {
    width: 300px;
    height: 300px;
    
    .earth {
      width: 200px;
      height: 200px;
    }
  }
}

@media (max-width: 480px) {
  .hero-section {
    height: 80vh;
  }
  
  .earth-container {
    width: 250px;
    height: 250px;
    
    .earth {
      width: 150px;
      height: 150px;
    }
  }
}
</style>